import { useState } from "react";

export type AddressCandidate = {
  street_address: string;
  city: string;
  state: string;
  post_code: string;
  country: string;
  place_id: string;
  formatted_address: string;
  latitude?: number;
  longitude?: number;
  confidence?: number;
};

export type AddressResolutionRow = {
  row: number;
  raw_parts: Record<string, string>;
  query: string;
  candidates: AddressCandidate[];
  error?: string | null;
};

export type AddressResolutionResult = {
  total_rows: number;
  rows: AddressResolutionRow[];
};

export type AddressOverride =
  | { mode: "skip" }
  | { mode: "use"; place_id: string };


export const useImportState = () => {
  const [file, setFile] = useState<File | null>(null);
  const [mapping, setMapping] = useState<Record<string, string>>({});
  const [activeStep, setActiveStep] = useState(0);
  const [validation, setValidation] = useState<any | null>(null);
  const [addressResolution, setAddressResolution] = useState<AddressResolutionResult | null>(null);
  const [addressOverrides, setAddressOverrides] = useState<Record<string, AddressOverride>>({});
  const [importResult, setImportResult] = useState<any | null>(null);
  const [uploading, setUploading] = useState(false);

  const updateMapping = (fileCol: string, modelField: string) =>
    setMapping((prev) => ({ ...prev, [fileCol]: modelField }));

  const invertMapping = () => {
    const m: Record<string, string> = {};
    Object.entries(mapping).forEach(([fileCol, modelField]) => {
      if (modelField) m[modelField] = fileCol;
    });
    return m;
  };

  const reset = () => {
    setFile(null);
    setMapping({});
    setActiveStep(0);
    setValidation(null);
    setAddressResolution(null);
    setAddressOverrides({});
    setImportResult(null);
  };

  return {
    file,
    setFile,
    mapping,
    updateMapping,
    invertMapping,
    activeStep,
    setActiveStep,
    validation,
    setValidation,
    addressResolution,
    setAddressResolution,
    addressOverrides,
    setAddressOverrides,
    importResult,
    setImportResult,
    uploading,
    setUploading,
    reset,
  };
};
